import { Dispatch, ThunkAction } from '../../../../../../../types/actions';

export const onTabSettingsActive = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
    };
    return action;
};
